import React from 'react';
import './Plasticcompared.css';

const Plasticcompared = () => {
    return (
        <div className="Plasticcomp-container">
            <div className='Plasticcompa'>
                <h2 className="Plasticcomp-title">The Advantages of Pure Plastic Compared to Plastic-clad Aluminum:</h2>
                <div className="Plasticcomp-content">
                    <ul className="Plasticcomp-text">
                        <li>Less weight, very popular material.</li>
                        <li>Lower production cos.</li>
                        <li>It is more convenient in the injection molding process, saving the action of putting the aluminum cup.</li>
                        <li>The design is more diverse and beautiful, such as diamond shape, wave shape.</li>
                    </ul>
                </div>
                <h1 className="Ordinar">Disadvantages of Pure Plastic Compared to Plastic-clad Aluminum:</h1>
                <div className="Plasticcomp-content">
                    <ul className="Plasticcomp-text">
                        <li>Heat dissipation deteriorate.</li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default Plasticcompared;
